<template>
  <el-menu
    v-if="!update"
    :mode="mode"
    :collapse="collapse"
    :menu-trigger="options.menuTrigger"
    :default-active="activeIndex"
    @open="(index, indexPath) => handleResetMenuPosition(index, indexPath, 0, true)"
    @close="handleResetMenuPosition"
    @select="handleSelect"
    :style="getAppearanceStyle"
    :class="[
      options.alignmentType ? 'rect_' + options.alignmentType : 'rect_left',options.showVerticalType ? 'verticalNavMenu':'',
      options.menuTrigger+'_animate',
      options.widthType === '自动' ? 'width-auto': '']"
    ref="navMenu"
  >
    <template v-for="(option, index) in selectOptions">
      <el-menu-item
        :style="getStyle(option)"
        v-if="!option.children || option.children.length === 0"
        :ref="'menuItem' + uuid"
        :key="index"
        :index="'' + index"
      >
        <span v-if="topNavTextHasLimitLine" :class="topNavTextLimit  && !topNavTextHasLimitwords ? 'overflowHidMultiLine' : ''" :style="navTextStyle">{{ option.label }}</span>
        <template v-else>{{
          topNavTextHasLimitwords ? option.label.substr(0, options.topNavTextLimitCount) : option.label
        }}</template>
        <!-- 分隔符 -->
        <div
          class="divide-box"
          v-if="index !== selectOptions.length - 1 && options.showDivide"
          :style="getDivideStyle('img')"
        >
          <span class="line" :style="getDivideStyle('line')" v-if="options.divideType !== 'custom'"></span>
          <cxIcon
            class="icon"
            v-if="divideIconType === 'icon' && options.divideType === 'custom'"
            :options="options"
            :iconStyle="getDivideStyle('icon')"
            iconSrcName="divideIconSrc"
          ></cxIcon>
          <img
            class="icon"
            v-else-if="divideIconType === 'img' && divideIconSrc && options.divideType === 'custom'"
            :src="divideIconSrc"
            :style="getDivideStyle('img')"
          />
        </div>
      </el-menu-item>
      <el-submenu
        :key="index"
        ref="menuItem"
        :style="getStyle(option)"
        :show-timeout="1"
        :hide-timeout="300"
        :popper-class="
          [$event.getIdsByStrId(myid) + '-' + index, getSubMenuType(option) !== 1 ? 'customMenu' : '', getSubMenuType(option) === 4 ? ' is-menu-three' : ''].join(' ')
        "
        :popper-append-to-body="false"
        @mouseenter.native="handleHover(index)"
        v-if="option.children && option.children.length > 0"
        :index="'' + index"
        :class="['sub_menu_' + alignTypes[index],'menuItem_'+index,'custom_style_'+getSubMenuType(option)]"
        @click.native="handleMenuClick(index, option, true)"
      >
        <template slot="title">
          <div :style="topNavTextHasLimitLine ? getFlex : ''">
          <span v-if="getIconPosition === 'right'" class="title_span" :class="topNavTextHasLimitLine ? 'overflowHidMultiLine' : ''" :style="navTextStyle">{{
            topNavTextHasLimitwords ? option.label.substr(0, options.topNavTextLimitCount) : option.label
          }}</span>
          <cxIcon
            class="icon"
            v-if="iconType === 'icon' && options.showTopNavIcon !== false"
            :options="options"
            :iconStyle="getIconStyle"
          ></cxIcon>
          <!-- <span class="icon" v-if="iconType === 'icon' && iconSrc" :class="iconSrc" :style="getIconStyle"></span> -->
          <img
            class="icon"
            v-else-if="iconType === 'img' && iconSrc && options.showTopNavIcon !== false"
            :src="iconSrc"
            :style="getIconImgStyle"
          />
          <span v-if="getIconPosition === 'left'" class="title_span" :class="topNavTextHasLimitLine ? 'overflowHidMultiLine' : ''" :style="navTextStyle">{{
            topNavTextHasLimitwords ? option.label.substr(0, options.topNavTextLimitCount) : option.label
          }}</span>
          <!-- 分隔符 -->
          <div
            class="divide-box"
            v-if="index !== selectOptions.length - 1 && options.showDivide"
            :style="getDivideStyle('img')"
          >
            <span class="line" :style="getDivideStyle('line')" v-if="options.divideType !== 'custom'"></span>
            <cxIcon
              class="icon"
              v-if="divideIconType === 'icon' && options.divideType === 'custom'"
              :options="options"
              :iconStyle="getDivideStyle('icon')"
              iconSrcName="divideIconSrc"
            ></cxIcon>
            <img
              class="icon"
              v-else-if="divideIconType === 'img' && divideIconSrc && options.divideType === 'custom'"
              :src="divideIconSrc"
              :style="getDivideStyle('img')"
            />
          </div>
          <!-- 连接符 -->
<!--          <div class="connect-box" v-if="getSubMenuType(option) === 4"  :style="getConnectorStyle(index)">-->
          <div class="connect-box" v-if="index == openedId || index == lastSettingIndex" :style="getConnectorStyle(option,getSubMenuType(option))">
            <div class="vertical-line"></div>
            <div class="hor-line"></div>
          </div>
          </div>
        </template>
        <MenuOne
          :menuData="option.children"
          v-if="getSubMenuType(option) === 2"
          :config="getSubMenuConfig(option)"
        ></MenuOne>
        <MenuTwo :menuData="option" v-if="getSubMenuType(option) === 3" :config="getSubMenuConfig(option)"></MenuTwo>
        <MenuThree
          :menuData="option.children"
          v-if="getSubMenuType(option) === 4"
          :config="getSubMenuConfig(option)"
          :menuIndex="index"
          :currentMenuIndex="lastSettingIndex"
          @menuLoaded="handleSubmenuLoaded"
        ></MenuThree>
        <cx-menu-tree
          v-if="getSubMenuType(option) === 1"
          class="sub-menu-style-one"
          :style="getPopperStyle"
          v-for="(child_option, child_index) in option.children"
          :key="'child_' + child_index"
          :items="child_option"
          :options="options"
          :myid="myid"
          :index="index + '_' + child_index"
          @handleMenuClick="handleMenuClick"
        />
      </el-submenu>
    </template>
  </el-menu>
</template>

<script>
import { v1 } from "uuid"
import eventMixin from "utils/event/eventMixin.js"
import MenuOne from "./customSubMenus/menuOne/render.vue"
import MenuTwo from "./customSubMenus/menuTwo/render.vue"
import MenuThree from "./customSubMenus/menuThree/render.vue"
import cxMenuTree from "./cxMenuTree.vue"
import { repairApp } from "utils/saveModule"
import { isExist, isPlainObject } from "utils"
import { propTypeMap, unitMap } from "materials/navMenu/render/customSubMenus/menuThree/defaultProps"
import propTrans from "materials/navMenu/render/customSubMenus/setting/propTrans"
import { idsFilter } from "utils/event/animate"
// import {setNavMenuActive} from "../../../../plugs/navMenuActive"
export default {
  mixins: [eventMixin],
  components: { cxMenuTree, MenuOne, MenuTwo, MenuThree },
  props: {
    options: {
      type: Object
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      disableOpen: false,
      activeIndex: "0",
      openedId: "0",
      update: false,
      uuid: v1(),
      lastSettingIndex: 0,
      loadedSubMenus: [],
      timer:null
    }
  },
  watch: {
    // 切换样式更新数据
    "options.encId": function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.initNavData()
      }
    },
    "options.appId": function (newVal, oldVal) {
      if(!sessionStorage.getItem("regenerateAppId")){
        return
      }
      sessionStorage.removeItem("regenerateAppId")
      if (newVal != oldVal) {
        this.initNavData(true)
      }
    }
  },
  computed: {
    alignTypes() {
      const aligns =  this.selectOptions.map(option => {
        const subMenuType = this.getSubMenuType(option)
        if (subMenuType == 2) {
          const config = this.getSubMenuConfig(option)
          return ['100vw', 'widthCenter'].includes(config?.navPopPosition) ? 'left' : (this.getSubMenuConfig(option)?.navPopPosition ?? 'left')
        } else if (subMenuType == 3) {
          const config = this.getSubMenuConfig(option)
          return ['100vw'].includes(config?.navPopPosition) ? 'left' : (this.getSubMenuConfig(option)?.navPopPosition ?? 'left')
        } else if (subMenuType == 1) {
          return this.options.ulAlignmentType ?? 'left'
        } else return 'left'
      })
      return aligns
    },
    ids() {
      return this.myid
    },
    getMyStrClassName() {
      const ids = {}
      for (let k in this.myid) {
        if (this.myid[k] !== null && this.myid[k] !== undefined) {
          ids[k] = this.myid[k]
        }
      }
      let res = ""
      for (let k in ids) {
        res += k + "-" + ids[k] + ";"
      }
      return res
    },
    mode() {
      return this.options.mode
    },
    collapse() {
      return this.options.collapse
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    iconSrc() {
      return this.options ? this.options.iconSrc : ""
    },
    iconType() {
      return this.options ? this.options.iconType : "img"
    },
    getIconPosition() {
      return this.options ? this.options.iconPosition : "left"
    },
    getMargin() {
      return this.options.iconPosition === "left"
        ? `0 ${this.options.iconMargin}px 0 0`
        : `0 0 0 ${this.options.iconMargin}px`
    },
    connectorStyle(){
      // 样式1的连接线单独设置
      let connectorColor = "var(--page-theme-color)"
      if(this.options.connectorColor && this.options.connectorColor.type=== 'color'){
        // let color
        // if (typeof this.options.connectorColor === 'object') {
        //   color = this.options.connectorColor.isThemeColor ? this.themeColor : this.options.connectorColor.color
        // }
        connectorColor = this.$parseColor(this.options.connectorColor)
      }
      return{
        "--connector-width": this.options.connectorWidth+'px',
        "--connector-display": this.options.showConnector ? "block" : "none",
        "--connector-color": connectorColor,
      }
    },
    getConnectorStyle() {
      return function (option,styleTypeId) {
        let padding = `0 ${this.options.topNavPadding}px 0 ${this.options.topNavPadding}px`
        if (!this.options.topNavPaddingTypeFlag || this.options.topNavPaddingTypeFlag === 2) {
          padding = ` 0  ${this.options.topNavPaddingRight}px  0  ${this.options.topNavPaddingLeft}px`
        }
        let subConfigs
        if(styleTypeId === 1) {
          return {
            ...this.connectorStyle,
            "--padding": padding
          }
        }
        subConfigs =  this.options.subMenuConfig.find(item=>item.menuId === option.publicId)
        if(!subConfigs || !subConfigs.extraConfig){
          return
        }
        const connectorSet = isPlainObject(subConfigs.extraConfig.connectorSet) ? subConfigs.extraConfig.connectorSet : subConfigs.extraConfig
        if (connectorSet) {
          subConfigs = this.finalConfig(this.getSubMenuConfig(option),connectorSet)
          return {
            "--connector-color": subConfigs.connectorColor || "var(--page-theme-color)",
            "--connector-width": subConfigs.connectorWidth,
            "--connector-display": subConfigs.showConnector ? "block" : "none",
            "--padding": padding
          }
        }
      }
    },
    getIconStyle() {
      // 行限制的时候图标没有居中
      let flex = this.topNavTextHasLimitLine ? this.getFlex : {}
      return {
        display: "inline-block",
        // "--color": this.options.iconColorIsThemeColor
        //   ? this.themeColor
        //   : this.options.iconColor && this.options.iconColor.color
        //   ? this.options.iconColor.color
        //   : this.options.iconColor,
        "--color": this.$parseColor(this.options.iconColor, {
          isThemeColor: this.options.iconColorIsThemeColor
        }),
        fontSize: this.options.iconWidth + "px",
        width: this.options.iconWidth + "px",
        height: this.options.iconWidth + "px",
        margin: this.getMargin,
        ...flex
      }
    },
    getIconImgStyle() {
      return {
        width: this.options.iconWidth + "px",
        margin: this.getMargin
      }
    },
    backgroundColor() {
      return this.options.bgIsThemeColor ? this.themeColor : this.options.bgColor
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    topNavBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.topNavBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.topNavBgColorIsThemeColor ? true : false,
            color: this.options.topNavBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    popperBgStyle() {
      let bgStr = this.getBgStyle(this.options.ulBackground)
      if (this.options.ulBackground === undefined) {
        if (this.options.ulBgColor && typeof this.options.ulBgColor === "object" && this.options.ulBgColor.color) {
          bgStr = {
            backgroundColor: this.$parseColor(this.options.ulBgColor)
          }
        }
      }
      return {
        "--ulBackgroundImage": bgStr.backgroundImage,
        "--ulBackgroundSize": bgStr.backgroundSize,
        "--ulBackgroundPosition": bgStr.backgroundPosition,
        "--ulBackgroundRepeat": bgStr.backgroundRepeat,
        "--ulBackgroundColor": bgStr.backgroundColor
      }
    },
    hoverBgStyle() {
      if (this.options.hoverIsSameActive) {
        return {
          "--hoverBackgroundImage": this.activeBg.backgroundImage,
          "--hoverBackgroundSize": this.activeBg.backgroundSize,
          "--hoverBackgroundPosition": this.activeBg.backgroundPosition,
          "--hoverBackgroundRepeat": this.activeBg.backgroundRepeat,
          "--hoverBackgroundColor": this.activeBg.backgroundColor
        }
      }
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.hoverBgColor
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hoverBgIsThemeColor ? true : false,
            color:
              this.options.hoverBgColor && this.options.hoverBgColor.color
                ? this.options.hoverBgColor.color
                : this.options.hoverBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return {
        "--hoverBackgroundImage": containerBg.backgroundImage,
        "--hoverBackgroundSize": containerBg.backgroundSize,
        "--hoverBackgroundPosition": containerBg.backgroundPosition,
        "--hoverBackgroundRepeat": containerBg.backgroundRepeat,
        "--hoverBackgroundColor": containerBg.backgroundColor
      }
    },
    activeBg() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.activeBgColor
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.activeBgIsThemeColor ? true : false,
            color:
              this.options.activeBgColor && this.options.activeBgColor.color
                ? this.options.activeBgColor.color
                : this.options.activeBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    activeBgStyle() {
      return {
        "--activeBackgroundImage": this.activeBg.backgroundImage,
        "--activeBackgroundSize": this.activeBg.backgroundSize,
        "--activeBackgroundPosition": this.activeBg.backgroundPosition,
        "--activeBackgroundRepeat": this.activeBg.backgroundRepeat,
        "--activeBackgroundColor": this.activeBg.backgroundColor
      }
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    topNavBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.topNavBoxShadowH)) {
        this.options.topNavBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.topNavBoxShadowH[index]}px ${_this.options.topNavBoxShadowV[index]}px ${_this.options.topNavBoxShadowBlur[index]}px ${_this.options.topNavBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.topNavBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.topNavBoxShadowH}px ${this.options.topNavBoxShadowV}px ${this.options.topNavBoxShadowBlur}px ${this.options.topNavBoxShadowSpread}px ${this.$parseColor(this.options.topNavBoxShadowColor)}`
      }
      return tmpStyle
    },
    selectBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.selectBoxShadowH)) {
        this.options.selectBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.selectBoxShadowH[index]}px ${_this.options.selectBoxShadowV[index]}px ${_this.options.selectBoxShadowBlur[index]}px ${_this.options.selectBoxShadowSpread[index]}px ${this.$parseColor(_this.options.selectBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.selectBoxShadowH}px ${this.options.selectBoxShadowV}px ${this.options.selectBoxShadowBlur}px ${this.options.selectBoxShadowSpread}px ${this.$parseColor(this.options.selectBoxShadowColor)}`
      }
      return tmpStyle
    },
    ulBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.ulBoxShadowH)) {
        this.options.ulBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.ulBoxShadowH[index]}px ${_this.options.ulBoxShadowV[index]}px ${_this.options.ulBoxShadowBlur[index]}px ${_this.options.ulBoxShadowSpread[index]}px ${_this.$parseColor(_this.options.ulBoxShadowColor[index])}`
        })
      } else if (this.options.ulBoxShadowH === undefined) {
        tmpStyle = ""
      } else {
        tmpStyle += `${this.options.ulBoxShadowH}px ${this.options.ulBoxShadowV}px ${this.options.ulBoxShadowBlur}px ${this.options.ulBoxShadowSpread}px ${this.$parseColor(this.options.ulBoxShadowColor)}`
      }
      return tmpStyle
    },
    getAppearanceStyle() {
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      console.log("bgStyle", this.bgStyle)
      return {
        ...this.bgStyle,
        "--backgroundColor": this.bgStyle.backgroundColor,
        opacity: this.options.opacity / 100,
        "border-style": this.options.borderStyle,
        // "border-color": this.options.borderIsThemeColor
        //   ? this.themeColor
        //   : this.options.borderColor && this.options.borderColor.color
        //   ? this.options.borderColor.color
        //   : this.options.borderColor,
        "border-color": this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor
        }),
        "border-width": this.options.showBorder !== false ? borderW : 0,
        "box-shadow": this.boxShadowStyle,
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        "--page-theme-color": this.themeColor,
        "--wrap": this.options.isWrap === false ? "nowrap" : "wrap",
        padding: this.getMenuPaddingStyle
      }
    },
    getMenuPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (!this.options.topPaddingTypeFlag || this.options.topPaddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px ${this.options.paddingRight}px ${this.options.paddingBottom}px ${this.options.paddingLeft}px`
      }
      return padding
    },
    getPaddingStyle() {
      let padding = `${this.options.topNavPadding}px`
      if (!this.options.topNavPaddingTypeFlag || this.options.topNavPaddingTypeFlag === 2) {
        padding = ` ${this.options.topNavPaddingTop}px  ${this.options.topNavPaddingRight}px  ${this.options.topNavPaddingBottom}px  ${this.options.topNavPaddingLeft}px`
      }
      return padding
    },
    getLiPaddingStyle() {
      let padding = `${this.options.liPadding}px`
      if (this.options.liPaddingTypeFlag === undefined) {
        padding = `0 10px 0 10px`
      } else if (!this.options.liPaddingTypeFlag || this.options.liPaddingTypeFlag === 2) {
        let liPaddingTop = this.options.liPaddingTop !== undefined ? this.options.liPaddingTop : 0
        let liPaddingRight = this.options.liPaddingRight !== undefined ? this.options.liPaddingRight : 10
        let liPaddingBottom = this.options.liPaddingBottom !== undefined ? this.options.liPaddingBottom : 0
        let liPaddingLeft = this.options.liPaddingLeft !== undefined ? this.options.liPaddingLeft : 10
        padding = ` ${liPaddingTop}px  ${liPaddingRight}px  ${liPaddingBottom}px  ${liPaddingLeft}px`
      }
      return padding
    },
    getUlPaddingStyle() {
      let padding = `${this.options.ulPadding}px`
      if (this.options.ulPaddingTypeFlag === undefined) {
        if (this.options.ulPadding === undefined) {
          padding = `0 0 0 0`
        }
      } else if (!this.options.ulPaddingTypeFlag || this.options.ulPaddingTypeFlag === 2) {
        let ulPaddingTop = this.options.ulPaddingTop !== undefined ? this.options.ulPaddingTop : 0
        let ulPaddingRight = this.options.ulPaddingRight !== undefined ? this.options.ulPaddingRight : 0
        let ulPaddingBottom = this.options.ulPaddingBottom !== undefined ? this.options.ulPaddingBottom : 0
        let ulPaddingLeft = this.options.ulPaddingLeft !== undefined ? this.options.ulPaddingLeft : 0
        padding = ` ${ulPaddingTop}px ${ulPaddingRight}px ${ulPaddingBottom}px ${ulPaddingLeft}px`
      }
      return padding
    },
    getStyle() {
      return function(option) {
        let topNavBorderW = "",
          activeBorderW = "",
          hoverBorderW = "",
          height =
            this.options.lineHeightType === "%"
              ? (this.options.lineHeight / 100) * this.options.fontSize
              : this.options.lineHeightType === "normal"? this.options.fontSize *1.5 :this.options.lineHeight,
          ulBorderW = "",
          topNavBorderWTB = ""

        if (Array.isArray(this.options.topNavBorderWidth)) {
          this.options.topNavBorderWidth.forEach(item => [(topNavBorderW += ` ${item}px`)])
          height = `${height}+${this.options.topNavBorderWidth[0]} + ${this.options.topNavBorderWidth[1]}px`
          topNavBorderWTB = this.options.topNavBorderWidth[0] + this.options.topNavBorderWidth[2]
        } else {
          topNavBorderW += ` ${this.options.topNavBorderWidth}px`
          height = `${height + 2 * this.options.topNavBorderWidth}px`
          topNavBorderWTB = 2 * this.options.topNavBorderWidth
        }
        if (this.options.showTopNavBorder === false) {
          topNavBorderW = 0
        }
        // 一级导航 选中边框
        if (Array.isArray(this.options.activeBorderWidth)) {
          this.options.activeBorderWidth.forEach(item => [(activeBorderW += ` ${item}px`)])
          topNavBorderWTB = this.options.activeBorderWidth[0] + this.options.activeBorderWidth[2]
        } else {
          activeBorderW += ` ${this.options.activeBorderWidth}px`
          topNavBorderWTB = 2 * this.options.activeBorderWidth
        }
        if (this.options.showTopNavActiveBorder === false) {
          activeBorderW = 0
        }

        // 二级导航框
        if (Array.isArray(this.options.ulBorderWidth)) {
          this.options.ulBorderWidth.forEach(item => [(ulBorderW += ` ${item}px`)])
        } else {
          ulBorderW += ` ${this.options.ulBorderWidth}px`
        }
        if (!this.options.showUlBorder) {
          ulBorderW = 0
        }

        if (Array.isArray(this.options.hoverBorderWidth)) {
          this.options.hoverBorderWidth.forEach(item => [(hoverBorderW += ` ${item}px`)])
        } else {
          hoverBorderW += ` ${this.options.hoverBorderWidth}px`
        }
        if (this.options.showTopNavHoverBorder === false) {
          hoverBorderW = 0
        }
        let bg = {
          "--backgroundImage": this.topNavBgStyle?.backgroundImage,
          "--backgroundSize": this.topNavBgStyle?.backgroundSize,
          "--backgroundPosition": this.topNavBgStyle?.backgroundPosition,
          "--backgroundRepeat": this.topNavBgStyle?.backgroundRepeat,
          "--backgroundColor": this.topNavBgStyle?.backgroundColor
        }
        // let activeColor = this.options.activeTextIsThemeColor
        //   ? this.themeColor
        //   : this.options.activeFontColor && this.options.activeFontColor.color
        //     ? this.options.activeFontColor.color
        //     : this.options.activeFontColor
        let activeColor = this.$parseColor(this.options.activeFontColor, {
          isThemeColor: this.options.activeTextIsThemeColor
        })
        //计算文字上中下居中
        let actualLineHeight =
          this.options.lineHeightType === "%"
            ? (this.options.lineHeight / 100) * this.options.fontSize
            : this.options.lineHeightType === "normal"? this.options.fontSize *1.5 : this.options.lineHeight
        let lineHeight1 = actualLineHeight,
          height1 = "",
          actualHoverLineHeight =
            this.options.hoverLineHeightType === "%"
              ? (this.options.hoverLineHeight / 100) * this.options.hoverFontSize
              : this.options.hoverLineHeightType === "normal"? this.options.hoverFontSize *1.5 : this.options.hoverLineHeight,
          actualActiveLineHeight =
            this.options.activeLineHeightType === "%"
              ? (this.options.activeLineHeight / 100) * this.options.activeFontSize
              : this.options.activeLineHeightType === "normal"? this.options.activeFontSize *1.5 :this.options.activeLineHeight,
          activeLineHeight1 = actualActiveLineHeight,
          activeHeight = "auto",
          hoverLineHeight = this.options.hoverIsSameActive ? actualActiveLineHeight : actualHoverLineHeight,
          hoverHeight = "auto"
        if (this.options.heightAuto === false) {
          let borderHeight = 0
          if (this.options.showTopNavBorder) {
            if (Array.isArray(this.options.topNavBorderWidth)) {
              borderHeight = Number(this.options.topNavBorderWidth[0] + this.options.topNavBorderWidth[2])
            } else {
              borderHeight = Number(this.options.topNavBorderWidth * 2)
            }
          }
          if (this.options.verticalAlign === "center") {
            lineHeight1 = this.options.navHeight
            if (borderHeight) {
              lineHeight1 = this.options.navHeight - borderHeight
            }
          } else if (this.options.verticalAlign === "bottom") {
            lineHeight1 = Number(this.options.navHeight * 2) - Number(actualLineHeight)
            if (borderHeight) {
              lineHeight1 = Number((this.options.navHeight - borderHeight) * 2) - Number(actualLineHeight)
            }
          }
          if (this.options.navHeight === undefined) height1 = "100%"
          else height1 = this.options.navHeight + "px"
          // 选中标题的文字 上中下居中
          let activeBorderHeight = 0
          if (this.options.showTopNavActiveBorder) {
            if (Array.isArray(this.options.activeBorderWidth)) {
              activeBorderHeight = Number(this.options.activeBorderWidth[0] + this.options.activeBorderWidth[2])
            } else {
              activeBorderHeight = Number(this.options.activeBorderWidth * 2)
            }
          }
          if (this.options.activeVerticalAlign === "center") {
            activeLineHeight1 = this.options.navHeight
            if (activeBorderHeight) {
              activeLineHeight1 = this.options.navHeight - activeBorderHeight
            }
          } else if (this.options.activeVerticalAlign === "bottom") {
            activeLineHeight1 = Number(this.options.navHeight * 2) - Number(actualActiveLineHeight)
            if (activeBorderHeight) {
              activeLineHeight1 =
                Number((this.options.navHeight - activeBorderHeight) * 2) - Number(actualActiveLineHeight)
            }
          }
          // 悬浮 标题的文字 上中下居中
          let hoverBorderHeight = 0
          if (this.options.showTopNavHoverBorder) {
            if (Array.isArray(this.options.hoverBorderWidth)) {
              hoverBorderHeight = Number(this.options.hoverBorderWidth[0] + this.options.hoverBorderWidth[2])
            } else {
              hoverBorderHeight = Number(this.options.hoverBorderWidth * 2)
            }
          }
          if (this.options.hoverVerticalAlign === "center") {
            hoverLineHeight = this.options.navHeight
            if (hoverBorderHeight) {
              hoverLineHeight = this.options.navHeight - hoverBorderHeight
            }
          } else if (this.options.hoverVerticalAlign === "bottom") {
            hoverLineHeight = Number(this.options.navHeight * 2) - Number(actualHoverLineHeight)
            if (hoverBorderHeight) {
              hoverLineHeight = Number((this.options.navHeight - hoverBorderHeight) * 2) - Number(actualHoverLineHeight)
            }
          }
          if (this.options.hoverIsSameActive) {
            hoverLineHeight = activeLineHeight1
          }
          activeHeight = height1
          hoverHeight = height1
        } else {
          // 高度自适应
          height1 = "auto"
        }
        let hoverBorderRadius = `${this.options.topNavHoverBorderTopLeftRadius}px ${this.options.topNavHoverBorderTopRightRadius}px ${this.options.topNavHoverBorderBottomRightRadius}px ${this.options.topNavHoverBorderBottomLeftRadius}px`
        if (this.options.hoverIsSameActive) {
          hoverBorderRadius = `${this.options.topNavActiveBorderTopLeftRadius}px ${this.options.topNavActiveBorderTopRightRadius}px ${this.options.topNavActiveBorderBottomRightRadius}px ${this.options.topNavActiveBorderBottomLeftRadius}px`
        }
        let ulMarginTop = this.options.ulMarginTop ? this.options.ulMarginTop : 0
        let ulTop1 =  0
        let ulTopDefault = 0
        let paddingTB = this.options.topNavPadding * 2
        if (!this.options.topNavPaddingTypeFlag || this.options.topNavPaddingTypeFlag === 2) {
          paddingTB = this.options.topNavPaddingTop + this.options.topNavPaddingBottom
        }
        if (this.options.heightAuto) {
          ulTop1 = hoverLineHeight + paddingTB + topNavBorderWTB + ulMarginTop
        } else {
          if (this.options.navHeight) {
            ulTop1 = this.options.navHeight + ulMarginTop
          } else {
            ulTop1 = lineHeight1 + paddingTB + topNavBorderWTB + ulMarginTop
          }
        }
        ulTopDefault = ulTop1
        if(this.getSubMenuType(option) === 1 && this.options.showConnector){
          // 25 是连接线的固定高度
          ulTop1+=25
        }
        const divideWidth = this.options.divideWidth || 1
        let divideMargin = 0
        if (this.options.navMargin !== undefined) divideMargin = -(this.options.navMargin + divideWidth) / 2
        let noSubHoverHeight = hoverHeight === "auto" ? hoverLineHeight + "px" : hoverHeight
        let noSubActiveHeight = activeHeight === "auto" ? activeLineHeight1 + "px" : activeHeight
        // 二级导航的高度固定，宽度自适应时，没有最大宽度时的文字不换行展示
        // let liWidthAutoWrap = true
        // if(this.options.liWidthAuto && !this.options.liShowMaxWidth && !this.options.liIsSameSizeHeight){
        //   liWidthAutoWrap = false
        // }
        let minWidth = this.options.liMinWidthVal
        let maxWidth = this.options.liMaxWidthVal
        if (!this.options.ulPaddingTypeFlag || this.options.ulPaddingTypeFlag === 2) {
          let ulPaddingRight = this.options.ulPaddingRight !== undefined ? this.options.ulPaddingRight : 0
          let ulPaddingLeft = this.options.ulPaddingLeft !== undefined ? this.options.ulPaddingLeft : 0
          minWidth = minWidth + ulPaddingLeft + ulPaddingRight
          maxWidth = maxWidth + ulPaddingLeft + ulPaddingRight
        } else if (this.options.ulPadding) {
          minWidth = minWidth + 2 * this.options.ulPadding
          maxWidth = maxWidth + 2 * this.options.ulPadding
        }
        let liBackground
        if (Array.isArray(this.options.ulBgColor)) {
          let bgStr = this.getBgStyle(this.options.ulBgColor)
          liBackground = {
            "--liBackgroundImage": bgStr.backgroundImage,
            "--liBackgroundSize": bgStr.backgroundSize,
            "--liBackgroundPosition": bgStr.backgroundPosition,
            "--liBackgroundRepeat": bgStr.backgroundRepeat,
            "--liBackgroundColor": bgStr.backgroundColor
          }
        } else {
          liBackground = {
            // "--liBackgroundColor": this.options.ulBgIsThemeColor
            //   ? this.themeColor
            //   : this.options.ulBgColor && this.options.ulBgColor.color
            //     ? this.options.ulBgColor.color
            //     : this.options.ulBgColor,
            "--liBackgroundColor": this.$parseColor(this.options.ulBgColor, {
              isThemeColor: this.options.ulBgIsThemeColor
            })
          }
        }

        return {
          ...bg,
          ...liBackground,
          ...this.activeBgStyle,
          ...this.hoverBgStyle,
          ...this.popperBgStyle,
          // "--liWidth": this.options.liWidthAuto === true ? "auto" : (this.options.liWidth + "px"),
          "--liMinWidth": this.options.liWidthAuto === true && this.options.liShowMinWidth ? minWidth + "px" : "initial",
          "--liMaxWidth": this.options.liWidthAuto === true && this.options.liShowMaxWidth ? maxWidth + "px" : "initial",
          // "--liHeight": this.options.liIsSameSizeHeight ? "auto" : (this.options.liHeight + "px"),
          "--lineHeight": lineHeight1 + "px",
          "--navWidth": this.options.widthAuto ? "" : this.options.navWidth + "px",
          "--height": this.options.heightAuto ? "auto" : this.options.navHeight + "px",
          "--ulTop": ulTop1 + "px",
          "--ulTopDefault": ulTopDefault + 'px',
          "--height1": height1,
          "--navMargin": this.options.navMargin + "px",
          "--divideMargin": divideMargin + "px",
          "--liMarginBottom": this.options.navMarginBottom + "px",
          // "--color": this.options.textIsThemeColor
          //   ? this.themeColor
          //   : this.options.color && this.options.color.color
          //     ? this.options.color.color
          //     : this.options.color,
          "--color": this.$parseColor(this.options.color, {
            isThemeColor: this.options.textIsThemeColor
          }),
          "--fontWeight": this.options.fontWeight,
          "--fontSize": this.options.fontSize + "px",
          "--fontFamily": this.options.fontFamily,
          "--background": this.backgroundColor,
          "--textAlign": this.options.textAlign,
          "--writingMode": this.options.writingMode,
          "--letterSpacing": this.options.letterSpacing + "px",
          "--textDecoration": this.options.textDecoration,
          "--fontStyle": this.options.fontStyle,
          "--borderRadius": `${this.options.topNavBorderTopLeftRadius}px ${this.options.topNavBorderTopRightRadius}px ${this.options.topNavBorderBottomRightRadius}px ${this.options.topNavBorderBottomLeftRadius}px`,
          "--borderStyle": this.options.topNavBorderStyle,
          // "--borderColor": this.options.topNavBorderIsThemeColor
          //   ? this.themeColor
          //   : this.options.topNavBorderColor && this.options.topNavBorderColor.color
          //     ? this.options.topNavBorderColor.color
          //     : this.options.topNavBorderColor,
          "--borderColor": this.$parseColor(this.options.topNavBorderColor, {
            isThemeColor: this.options.topNavBorderIsThemeColor
          }),
          "--borderWidth": topNavBorderW,
          "--boxShadow": this.topNavBoxShadowStyle,
          "--padding": this.getPaddingStyle,
          "--activeBorderWidth": activeBorderW,
          "--activeBorderStyle": this.options.activeBorderStyle,
          // "--activeBorderColor": this.options.activeBorderIsThemeColor
          //   ? this.themeColor
          //   : this.options.activeBorderColor && this.options.activeBorderColor.color
          //     ? this.options.activeBorderColor.color
          //     : this.options.activeBorderColor,
          "--activeBorderColor": this.$parseColor(this.options.activeBorderColor, {
            isThemeColor: this.options.activeBorderIsThemeColor
          }),
          "--activeColor": activeColor,
          "--activeFontWeight": this.options.activeFontWeight,
          "--activeFontSize": this.options.activeFontSize + "px",
          "--activeFontFamily": this.options.activeFontFamily,
          "--activeTextAlign": this.options.activeTextAlign,
          "--activeLineHeight": activeLineHeight1 + "px",
          "--activeWritingMode": this.options.activeWritingMode,
          "--activeLetterSpacing": this.options.activeLetterSpacing + "px",
          "--activeTextDecoration": this.options.activeTextDecoration,
          "--activeFontStyle": this.options.activeFontStyle,
          "--activeBorderRadius": `${this.options.topNavActiveBorderTopLeftRadius}px ${this.options.topNavActiveBorderTopRightRadius}px ${this.options.topNavActiveBorderBottomRightRadius}px ${this.options.topNavActiveBorderBottomLeftRadius}px`,
          "--selectBoxShadowStyle": this.selectBoxShadowStyle,
          // "--hoverBorderColor": this.options.hoverIsSameActive
          //   ? this.options.activeBorderIsThemeColor
          //     ? this.themeColor
          //     : this.options.activeBorderColor && this.options.activeBorderColor.color
          //       ? this.options.activeBorderColor.color
          //       : this.options.activeBorderColor
          //   : this.options.hoverBorderIsThemeColor
          //     ? this.themeColor
          //     : this.options.hoverBorderColor && this.options.hoverBorderColor.color
          //       ? this.options.hoverBorderColor.color
          //       : this.options.hoverBorderColor,
          "--hoverBorderColor": this.options.hoverIsSameActive ? this.$parseColor(this.options.activeBorderColor, {
            isThemeColor: this.options.activeBorderIsThemeColor
          }) : this.$parseColor(this.options.hoverBorderColor, {
            isThemeColor: this.options.hoverBorderIsThemeColor
          }),
          // "--hoverColor": this.options.hoverIsSameActive
          //   ? activeColor
          //   : this.options.hoverTextIsThemeColor
          //     ? this.themeColor
          //     : this.options.hoverFontColor && this.options.hoverFontColor.color
          //       ? this.options.hoverFontColor.color
          //       : this.options.hoverFontColor,
          "--hoverColor": this.options.hoverIsSameActive ? activeColor : this.$parseColor(this.options.hoverFontColor, {
            isThemeColor: this.options.hoverTextIsThemeColor
          }),
          "--hoverBorderWidth": this.options.hoverIsSameActive ? activeBorderW : hoverBorderW,
          "--hoverBorderStyle": this.options.hoverIsSameActive
            ? this.options.activeBorderStyle
            : this.options.hoverBorderStyle,
          "--hoverFontWeight": this.options.hoverIsSameActive
            ? this.options.activeFontWeight
            : this.options.hoverFontWeight,
          "--hoverFontSize": this.options.hoverIsSameActive
            ? this.options.activeFontSize + "px"
            : this.options.hoverFontSize + "px",
          "--hoverFontFamily": this.options.hoverIsSameActive
            ? this.options.activeFontFamily
            : this.options.hoverFontFamily,
          "--hoverTextAlign": this.options.hoverIsSameActive ? this.options.activeTextAlign : this.options.hoverTextAlign,
          "--hoverHeight": hoverHeight,
          "--hoverLineHeight": hoverLineHeight + "px",
          "--noSubHoverHeight": noSubHoverHeight,
          "--hoverWritingMode": this.options.hoverIsSameActive
            ? this.options.activeWritingMode
            : this.options.hoverWritingMode,
          "--hoverLetterSpacing": this.options.hoverIsSameActive
            ? this.options.activeLetterSpacing + "px"
            : this.options.hoverLetterSpacing + "px",
          "--hoverTextDecoration": this.options.hoverIsSameActive
            ? this.options.activeTextDecoration
            : this.options.hoverTextDecoration,
          "--hoverFontStyle": this.options.hoverIsSameActive ? this.options.activeFontStyle : this.options.hoverFontStyle,
          "--hoverBorderRadius": hoverBorderRadius,
          // "--liBackground": liBackground,
          "--opacity": this.options.hasOwnProperty("menuOpacity") ? this.options.menuOpacity / 100 : 1,
          "--topNavOpacity": this.options.topNavOpacity
            ? this.options.topNavOpacity / 100
            : this.options.topNavOpacity === 0
              ? 0
              : 1,
          "--topNavRotate": "rotate(" + (this.options.topNavRotate ? this.options.topNavRotate : 0) + "deg)",
          "--activeHeight": activeHeight,
          "--noSubActiveHeight": noSubActiveHeight,
          "--popperWidth": this.options.liWidthAuto ? undefined : this.options.liWidth + "px",
          "--popperHeight": this.options.ulHeightAuto ? undefined : this.options.ulHeight + "px",
          "--ulBorderWidth": ulBorderW,
          "--ulBorderStyle": this.options.ulBorderStyle ? this.options.ulBorderStyle : "solid",
          // "--ulBorderColor": this.options.ulBorderIsThemeColor
          //   ? this.themeColor
          //   : this.options.ulBorderColor && this.options.ulBorderColor.color
          //     ? this.options.ulBorderColor.color
          //     : this.options.ulBorderColor,
          "--ulBorderColor": this.$parseColor(this.options.ulBorderColor, {
            isThemeColor: this.options.ulBorderIsThemeColor
          }),
          "--ulBorderRadius": `${this.options.ulBorderTopLeftRadius}px ${this.options.ulBorderTopRightRadius}px ${this.options.ulBorderBottomRightRadius}px ${this.options.ulBorderBottomLeftRadius}px`,
          "--ulPadding": this.getUlPaddingStyle,
          "--ulOpacity": this.options.ulOpacity ? this.options.ulOpacity / 100 : this.options.ulOpacity === 0 ? 0 : 1,
          "--ulRotate": "rotate(" + (this.options.ulRotate ? this.options.ulRotate : 0) + "deg)",
          "--ulBoxShadow": this.ulBoxShadowStyle
        }
      }
    },
    getPopperStyle() {
      let borderW = "",
        hoverBorderW = "",
        activeBorderW = ""
      // 默认边框
      if (Array.isArray(this.options.liBorderWidth)) {
        this.options.liBorderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.liBorderWidth}px`
      }
      borderW = borderW.trim()
      let borderBottomWidth = this.options.clearLiLastBorder
        ? "0px"
        : borderW.split(" ").length > 1
        ? borderW.split(" ")[2]
        : borderW
      if (this.options.showLiBorder === false) {
        borderW = 0
        borderBottomWidth = 0
      }
      // 悬浮边框
      if (Array.isArray(this.options.liHoverBorderWidth)) {
        this.options.liHoverBorderWidth.forEach(item => [(hoverBorderW += ` ${item}px`)])
      } else {
        hoverBorderW += ` ${this.options.liHoverBorderWidth}px`
      }
      hoverBorderW = hoverBorderW.trim()
      let liHoverBorderBottomWidth = this.options.clearLiLastHoverBorder
          ? "0px"
          : hoverBorderW.split(" ").length > 1
              ? hoverBorderW.split(" ")[2]
              : hoverBorderW
      if (this.options.showLiHoverBorder === false) {
        hoverBorderW = 0
        liHoverBorderBottomWidth = 0
      }
      // 选中边框
      if (Array.isArray(this.options.liActiveBorderWidth)) {
        this.options.liActiveBorderWidth.forEach(item => [(activeBorderW += ` ${item}px`)])
      } else {
        activeBorderW += ` ${this.options.liActiveBorderWidth}px`
      }
      activeBorderW = activeBorderW.trim()
      let liActiveBorderBottomWidth = activeBorderW.split(" ").length > 1
              ? activeBorderW.split(" ")[2]
              : activeBorderW
      if (this.options.showLiActiveBorder === false) {
        activeBorderW = 0
        liActiveBorderBottomWidth = 0
      }
      //计算 二级导航 文字上中下居中
      let actualLiLineHeight =
        this.options.liLineHeightType === "%"
          ? (this.options.liLineHeight / 100) * this.options.liFontSize
          : this.options.liLineHeightType === "normal" ? this.options.liFontSize * 1.5: this.options.liLineHeight
      let actualLiHoveLineHeight =
        this.options.liHoverLineHeightType === "%"
          ? (this.options.liHoverLineHeight / 100) * this.options.liHoverFontSize
            : this.options.liHoverLineHeightType === "normal" ? this.options.liHoverFontSize * 1.5 :
                this.options.liHoverLineHeight
      let lineHeight2 = actualLiLineHeight,
        liHoverLineHeight = actualLiHoveLineHeight,
        borderWidthNumber = 0,
        borderBottomWidthLineHeight0 = actualLiLineHeight

      let actualLiActiveLineHeight =
        this.options.liActiveLineHeightType === "%"
          ? (this.options.liActiveLineHeight / 100) * this.options.liActiveFontSize
          : this.options.liActiveLineHeightType === "normal" ? this.options.liActiveFontSize * 1.5
          : this.options.liActiveLineHeight
      let liActiveLineHeight = actualLiActiveLineHeight

      if (this.options.liIsSameSizeHeight === false) {
        // 高度固定
        if (this.options.showLiBorder === true) {
          if (Array.isArray(this.options.liBorderWidth)) {
            borderWidthNumber = this.options.liBorderWidth[1] + this.options.liBorderWidth[3]
            if (this.options.clearLiLastBorder) {
              borderBottomWidthLineHeight0 = this.options.liHeight - this.options.liBorderWidth[1]
            } else {
              borderBottomWidthLineHeight0 = this.options.liHeight - borderWidthNumber
            }
          } else {
            borderWidthNumber = this.options.liBorderWidth + this.options.liBorderWidth
            if (this.options.clearLiLastBorder) {
              borderBottomWidthLineHeight0 = this.options.liHeight - this.options.liBorderWidth
            } else {
              borderBottomWidthLineHeight0 = this.options.liHeight - borderWidthNumber
            }
          }
        }
        lineHeight2 = lineHeight2 - borderWidthNumber
      } else if (this.options.liIsSameSizeHeight === undefined) {
        // 兼容旧数据
        lineHeight2 = this.options.liHeight
        borderBottomWidthLineHeight0 = this.options.liHeight
        liHoverLineHeight = this.options.liHeight
      } else {
        // 高度自适应
      }
      // 二级导航的高度固定，宽度自适应时，没有最大宽度时的文字不换行展示
      let liWidthAutoWrap = true
      if (this.options.liWidthAuto && !this.options.liShowMaxWidth && !this.options.liIsSameSizeHeight) {
        liWidthAutoWrap = false
      }
      let hoverBackground
      if(Array.isArray(this.options.liHoverBgColor)){
        let bgStr =  this.getBgStyle(this.options.liHoverBgColor)
        hoverBackground = {
          "--liHoverBackgroundImage": bgStr.backgroundImage,
          "--liHoverBackgroundSize": bgStr.backgroundSize,
          "--liHoverBackgroundPosition": bgStr.backgroundPosition,
          "--liHoverBackgroundRepeat": bgStr.backgroundRepeat,
          "--liHoverBackgroundColor": bgStr.backgroundColor
        }
      }else{
        hoverBackground = {
          // "--liHoverBackgroundColor": this.options.liHoverBgIsThemeColor
          //   ? this.themeColor
          //   : this.options.liHoverBgColor && this.options.liHoverBgColor.color
          //     ? this.options.liHoverBgColor.color
          //     : this.options.liHoverBgColor
          "--liHoverBackgroundColor": this.$parseColor(this.options.liHoverBgColor, {
            isThemeColor: this.options.liHoverBgIsThemeColor
          }),
        }
      }

      let activeBackground
      if(Array.isArray(this.options.liActiveBgColor)) {
        let bgStr = this.getBgStyle(this.options.liActiveBgColor)
        activeBackground = {
          "--liActiveBackgroundImage": bgStr.backgroundImage,
          "--liActiveBackgroundSize": bgStr.backgroundSize,
          "--liActiveBackgroundPosition": bgStr.backgroundPosition,
          "--liActiveBackgroundRepeat": bgStr.backgroundRepeat,
          "--liActiveBackgroundColor": bgStr.backgroundColor
        }
      } else {
        activeBackground = {
          // "--liActiveBackgroundColor": this.options.liActiveBgIsThemeColor
          //   ? this.themeColor
          //   : this.options.liActiveBgColor && this.options.liActiveBgColor.color
          //     ? this.options.liActiveBgColor.color
          //     : this.options.liActiveBgColor
          "--liActiveBackgroundColor": this.$parseColor(this.options.liActiveBgColor, {
            isThemeColor: this.options.liActiveBgIsThemeColor
          }),
        }
      }
      return {
        ...hoverBackground,
        ...activeBackground,
        "--liWidth": this.options.liWidthAuto === true ? "auto" : this.options.liWidth + "px",
        "--liWidthAutoWrap": liWidthAutoWrap ? "normal" : "nowrap",
        "--liHeight": this.options.liIsSameSizeHeight ? "auto" : this.options.liHeight + "px",
        "--liLineHeight": lineHeight2 + "px",
        // "--color": this.options.liIsThemeColor
        //   ? this.themeColor
        //   : this.options.liFontColor && this.options.liFontColor.color
        //   ? this.options.liFontColor.color
        //   : this.options.liFontColor,
        "--color": this.$parseColor(this.options.liFontColor, {
          isThemeColor: this.options.liIsThemeColor
        }),
        "--fontWeight": this.options.liFontWeight,
        "--fontSize": this.options.liFontSize + "px",
        "--fontStyle": this.options.liFontStyle,
        "--fontFamily": this.options.liFontFamily,
        "--textAlign": this.options.liTextAlign,
        "--writingMode": this.options.liWritingMode,
        "--letterSpacing": this.options.liLetterSpacing + "px",
        "--textDecoration": this.options.liTextDecoration,
        "--liBorderWidth": borderW,
        "--borderBottomWidth": borderBottomWidth,
        "--borderBottomWidthLineHeight0": borderBottomWidthLineHeight0 + "px",
        "--borderStyle": this.options.liBorderStyle,
        // "--borderColor": this.options.liBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.liBorderColor && this.options.liBorderColor.color
        //   ? this.options.liBorderColor.color
        //   : this.options.liBorderColor,
        "--borderColor": this.$parseColor(this.options.liBorderColor, {
          isThemeColor: this.options.liBorderIsThemeColor
        }),
        "--liBorderRadius": `${this.options.liBorderTopLeftRadius}px ${this.options.liBorderTopRightRadius}px ${this.options.liBorderBottomRightRadius}px ${this.options.liBorderBottomLeftRadius}px`,
        "--liPadding": this.getLiPaddingStyle,
        "--liOpacity": this.options.liOpacity ? this.options.liOpacity / 100 : this.options.liOpacity === 0 ? 0 : 1,
        "--liRotate": "rotate(" + (this.options.liRotate ? this.options.liRotate : 0) + "deg)",
        // "--hoverColor": this.options.liHoverTextIsThemeColor
        //   ? this.themeColor
        //   : this.options.liHoverFontColor && this.options.liHoverFontColor.color
        //   ? this.options.liHoverFontColor.color
        //   : this.options.liHoverFontColor,
        "--hoverColor": this.$parseColor(this.options.liHoverFontColor, {
          isThemeColor: this.options.liHoverTextIsThemeColor
        }),
        "--hoverFontWeight": this.options.liHoverFontWeight,
        "--hoverFontSize": this.options.liHoverFontSize + "px",
        "--hoverFontFamily": this.options.liHoverFontFamily,
        "--hoverTextAlign": this.options.liHoverTextAlign,
        "--hoverWritingMode": this.options.liHoverWritingMode,
        "--hoverLetterSpacing": this.options.liHoverLetterSpacing + "px",
        "--hoverTextDecoration": this.options.liHoverTextDecoration,
        "--liHoverBorderWidth": hoverBorderW,
        "--liHoverBorderBottomWidth": liHoverBorderBottomWidth,
        "--liHoverBorderStyle": this.options.liHoverBorderStyle,
        // "--liHoverBorderColor": this.options.liHoverBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.liHoverBorderColor && this.options.liHoverBorderColor.color
        //   ? this.options.liHoverBorderColor.color
        //   : this.options.liHoverBorderColor,
        "--liHoverBorderColor": this.$parseColor(this.options.liHoverBorderColor, {
          isThemeColor: this.options.liHoverBorderIsThemeColor
        }),
        "--liMargin": this.options.liMargin + "px",
        "--liHoverFontStyle": this.options.liHoverFontStyle,
        "--liHoverLineHeight": liHoverLineHeight + "px",
        "--liHoverBorderRadius": `${this.options.liHoverBorderTopLeftRadius}px ${this.options.liHoverBorderTopRightRadius}px ${this.options.liHoverBorderBottomRightRadius}px ${this.options.liHoverBorderBottomLeftRadius}px`,
        // "--activeColor": this.options.liActiveTextIsThemeColor
        //   ? this.themeColor
        //   : this.options.liActiveFontColor && this.options.liActiveFontColor.color
        //   ? this.options.liActiveFontColor.color
        //   : this.options.liActiveFontColor,
        "--activeColor": this.$parseColor(this.options.liActiveFontColor, {
          isThemeColor: this.options.liActiveTextIsThemeColor
        }),
        "--activeFontWeight": this.options.liActiveFontWeight,
        "--activeFontSize": this.options.liActiveFontSize + "px",
        "--activeFontFamily": this.options.liActiveFontFamily,
        "--activeTextAlign": this.options.liActiveTextAlign,
        "--activeWritingMode": this.options.liActiveWritingMode,
        "--activeLetterSpacing": this.options.liActiveLetterSpacing + "px",
        "--activeTextDecoration": this.options.liActiveTextDecoration,
        "--liActiveBorderWidth": activeBorderW,
        "--liActiveBorderBottomWidth": liActiveBorderBottomWidth,
        "--liActiveBorderStyle": this.options.liActiveBorderStyle,
        // "--liActiveBorderColor": this.options.liActiveBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.liActiveBorderColor && this.options.liActiveBorderColor.color
        //   ? this.options.liActiveBorderColor.color
        //   : this.options.liActiveBorderColor,
        "--liActiveBorderColor": this.$parseColor(this.options.liActiveBorderColor, {
          isThemeColor: this.options.liActiveBorderIsThemeColor
        }),
        "--liActiveFontStyle": this.options.liActiveFontStyle,
        "--liActiveLineHeight": liActiveLineHeight + "px",
        "--liActiveBorderRadius": `${this.options.liActiveBorderTopLeftRadius}px ${this.options.liActiveBorderTopRightRadius}px ${this.options.liActiveBorderBottomRightRadius}px ${this.options.liActiveBorderBottomLeftRadius}px`,
      }
    },
    selectOptions() {
      return this.options.selectOptions
    },
    divideIconSrc() {
      return this.options ? this.options.divideIconSrc : ""
    },
    divideIconType() {
      return this.options ? this.options.divideIconType : "icon"
    },
    getDivideStyle() {
      return function (type) {
        let style = {}
        // const color = this.options.divideIconColorIsThemeColor
        //   ? this.themeColor
        //   : this.options.divideIconColor && this.options.divideIconColor.color
        //   ? this.options.divideIconColor.color
        //   : this.options.divideIconColor
        const color = this.$parseColor(this.options.divideIconColor, {
          isThemeColor: this.options.divideIconColorIsThemeColor
        })
        const width = this.options.divideWidth || 1
        const height = this.options.divideHeight || 24
        style = {
          width: width + "px",
          height: height + "px"
        }
        switch (type) {
          case "line":
            style = {
              ...style,
              backgroundColor: color
            }
            break
          case "icon":
            style = {
              ...style,
              "--color": color
            }
            break
          case "img":
            break
        }
        return style
      }
    },
    topNavTextLimit() {
      return this.options.topNavTextLimit
    },
    // 判断是否按字数限制
    topNavTextHasLimitwords() {
      return this.topNavTextLimit && this.options.topNavTextLimitRadio == "字数"
    },
    // 判断是否按行数限制
    topNavTextHasLimitLine() {
      return this.topNavTextLimit && this.options.topNavTextLimitRadio == "行数" && !this.options.widthAuto
    },
    navTextStyle() {
      if(this.topNavTextHasLimitLine) {
        return {
          "-webkit-line-clamp": this.options.topNavTextLimitLines,
          "white-space": "break-spaces",
          "flex": 1
        }
      }
      return
    },
    getFlex() {
      return {
        display: "flex",
        "align-items": "center"
      }
    }
  },
  methods: {
    handleSubmenuLoaded(data) {
      if (data.index !== this.lastSettingIndex ) return
      const existIndex = this.loadedSubMenus.findIndex(item => item.index === data.index)
      if (existIndex !== -1) {
        this.loadedSubMenus.splice(existIndex, 1, data)
      } else {
        this.loadedSubMenus.push(data)
      }
    },
    finalConfig(option,defaultProps) {
      const config = {...JSON.parse(JSON.stringify(defaultProps))}
      Object.entries(option).forEach(([key, value]) => {
        if (isPlainObject(value) && isPlainObject(config[key])) {
          config[key] = {...config[key], ...value}
        } else if ([Boolean, String, Number].includes(typeof value)) {
          config[key] = value + (unitMap[key] || '')
        } else {
          config[key] = option[key] ?? config[key]
        }
      })
      Object.entries(config).forEach(([key, value]) => {
        if (['number', 'string'].includes(typeof value)) {
          config[key] = value + (unitMap[key] || '')
        }
        if (propTrans[propTypeMap[key]]) {
          config[key] = propTrans[propTypeMap[key]](value)
        }
      })
      return config
    },
    getSubMenuType(option) {
      if (this?.options?.subMenuConfig?.length) {
        return this.options.subMenuConfig.find(item => item.menuId === option.publicId)?.styleId || 1
      }
      return 1
    },
    getSubMenuConfig(option) {
      let subMenuConfig
      if (this?.options?.subMenuConfig?.length) {
        subMenuConfig = this.options.subMenuConfig.find(item => item.menuId === option.publicId)?.extraConfig
      }
      return subMenuConfig || {}
    },
    handleHover(index){
      if(this.options.menuTrigger === 'hover'){
        this.openedId = index
      }
    },
    handleResetMenuPosition(index, path, deep = 0,isOpen) {
      if(isOpen){
        // 判断当前是否是展开
        this.openedId = index
      }
      //处理下拉框位置歪了的问题
      setTimeout(() => {
        const el = document.getElementsByClassName(this.$event.getIdsByStrId(this.myid) + "-" + index)[0]
        const relativeEl = el.parentNode
        const rect = relativeEl ? relativeEl.getBoundingClientRect() : { left: 0 }
        const windowWidth = window.innerWidth
        const subLeft =
          windowWidth - rect.left > el.offsetWidth ? 0 : windowWidth - rect.left - el.offsetWidth - 2 + "px"
        el.style.left = subLeft
        el.style.top = relativeEl.offsetTop + relativeEl.offsetHeight + "px"
        if (deep < 10) this.handleResetMenuPosition(index, path, deep + 1, isOpen)
      }, 0)
    },
    handleMenuClick(index, option,isFirstMenu) {
      if (option.openType === 2 && option.value && option.value.indexOf("http") > -1) {
        // 跳转外链
        // let target = option.openTarget === 2 ? '_blank':'_self'
        // mhDetail(option.value, target)
      }
      //  准备动画
        if(!isFirstMenu || this.options.menuTrigger !== "click"){
          return
        }
        let item = this.$el.getElementsByClassName(`menuItem_${index}`)[0]
        if(!item || !item.classList){
          return
        }
        if(item.classList.contains("is-opened")){
           item.classList.add("animate-in")
        }else{
           item.classList.remove("animate-in")
        }
    },
    handleSelect(path) {
      let pathArr = path.split("_")
      let val = {
        children: JSON.parse(JSON.stringify(this.selectOptions))
      }
      pathArr.forEach(pathIndex => {
        val = val.children[parseInt(pathIndex)]
      })
      let url = val.value
      if (this.myid.directionIndex) {
        // 说明当前组件是在自由布局组件中
        this.$store.dispatch(this.request_prefix + "/changeTitleOptions", {
          ...this.myid,
          option_name: "value",
          option_val: url
        })
      } else {
        // this.$store.dispatch(this.request_prefix + "/changeOptions", {
        //   ...this.myid,
        //   option_name: "value",
        //   option_val: url
        // })
        this.$changeOptionsEV(url, "value", false)
      }

      // 此功能是用来保证 有下拉的时候，点击调走，不改变激活项
      this.$nextTick(() => {
        let item = this.$refs["menuItem" + this.uuid]
        if (!item) return
        if (pathArr.length > 1) {
          item[this.activeIndex].$el.classList.add("is-active")
          item[pathArr[0]].$el.classList.remove("is-active")
        } else {
          if (item[this.activeIndex]) {
            item[this.activeIndex].$el.classList.remove("is-active")
            this.activeIndex = path
          }
        }
      })
      if (!url) {
        return
      }
      if (this.request_prefix === "bigScreen" && this.isBigScreenPreview()) {
        if (val.ifNewOpenLog == "_blank") {
          window.open(url)
        } else {
          window.location.href = url
        }
      }
      if (this.request_prefix !== "bigScreen" && !this.isSsrPage) {
        return
      }
    },
    async getGeneralRest(appId, wfwfid, websiteId, pageId) {
      return this.$API.queryAppCategoryAndApp({
        appId: appId,
        wfwfid: wfwfid,
        websiteId: websiteId,
        pageId: pageId
      })
    },
    doObj(datas, targetData) {
      for (let key in datas) {
        targetData.push({
          alias: datas[key].alias,
          label: datas[key].name,
          value: datas[key].url,
          iconUrl: datas[key].iconUrl,
          publicId: datas[key].publicId,
          openTarget: datas[key].openTarget, // 1 当前窗口 2 新窗口
          openType: datas[key].openType, // 1 自定义页面 2 链接地址
          showType: datas[key].showType, // openType === 1 时  【0: 默认，1：列表、2：简介、3：简介+列表 4：简介+分类列】
          children: []
        })
        if (typeof datas[key].subGeneralDataTypes == "object") {
          this.doObj(datas[key].subGeneralDataTypes, targetData[key].children)
        }
      }
    },
    setMyFetchParam(appId) {
      const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
      this.$changeOptionsEV(
        {
          pageId: pageId,
          wfwfid,
          websiteId,
          appId
        },
        "myFetchParam",
        false,
        null,
        this.myid,
        true
      )
    },
    handleRepairApp(appId) {
      // 根据当前appid，获取到对应的组件
      const _ids = this.ids
      const options = this.options
      // 需要判断当前组件类型，如果是基于自由布局开发的搜索组件/导航菜单，需要特殊处理
      const isSearchComponent = options.pluginName?.includes("searchComponentPlugin")
      const isNavComponent = options.innerElement.toLowerCase().includes("nav")
      repairApp.call(this, "31CB73E03E24BBFF", "临时", appId, false, isSearchComponent, isNavComponent).then(res => {
        // 替换原来的appId
        console.log("// 替换原来的appId", _ids)
        if (!!res.appId) {
          this.$changeOptionsEV(res.appId, "appId", null, false, _ids)
        }
      })
    },
    async initNavData(isHandleSubmenu) {
      const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
      const appId = this.options.appId
      let res = await this.getGeneralRest(appId, wfwfid, websiteId, pageId)
      let datas,
        targetData = []
      this.setMyFetchParam(appId) // 设置请求参数
      // 脏数据处理
      if (res.data.message === "mh_engine_40009") {
        this.handleRepairApp(appId)
      }
      if (res.data.code === 1) {
        const engineInstanceId = res.data.data.engineInstance.publicId
        this.$changeOptionsEV(engineInstanceId, "engineInstanceId", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id
        })
        datas = res.data.data.generalDataTypes
        this.engineInstanceRealId = res.data.data.engineInstance.id
        //获取数据推送需要的属性
        this.$changeOptionsEV(res.data.data.engineInstance.id, "engineInstanceId_10", false)
        this.doObj(datas, targetData)
        if(isHandleSubmenu && Array.isArray(this.options.subMenuConfig)){
          // 克隆的数据应该和克隆前的数据保持一致，所以未再做数据对比
          let publicRelative = []
          this.selectOptions.forEach((options,index)=>{
            publicRelative.push({
              oldId: options.publicId,
              newId: targetData[index].publicId
            })
          })
          const subMenuConfig = JSON.parse(JSON.stringify(this.options.subMenuConfig))
          subMenuConfig.forEach((config,index)=>{
            const tempConfig = publicRelative.find(item=>item.oldId === config.menuId)
            if(tempConfig){
              subMenuConfig[index].menuId = tempConfig.newId
            }
          })
          this.$changeOptionsEV(subMenuConfig, "subMenuConfig", false)
        }
        this.$changeOptionsEV(targetData, "selectOptions", false)
      }
    },
    getBgStyle(curBackground) {
      let containerBg = {
        backgroundImage: ""
      }
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    }
  },
  mounted() {
    const self = this
    if (this.options.appId) {
      this.initNavData()
    }
    this.$eventBus.$on("openSelectedSubMenu", data => {
      const { rect_id, publicId } = data
      if (self?.myid?.rect_id === rect_id) {
        const menuIndex = self.selectOptions.findIndex(item => item.publicId === publicId)
        if (menuIndex !== undefined && menuIndex !== null) {
          self.$refs.navMenu.open(menuIndex)
          menuIndex !== self.lastSettingIndex && self.$refs.navMenu.close("" + self.lastSettingIndex)
          self.lastSettingIndex = menuIndex
        }
      }
    })
    this.$eventBus.$on("updateConnectorStyle",()=>{
      if(self.myid.rect_id == self.$store.state.states.activeID.rect_id) {
        // 更新连接线设置效果
        let oldOpenedId = self.lastSettingIndex || self.openedId
        self.openedId = null
        self.timer = setTimeout(()=>{
          self.openedId = oldOpenedId
          self.timer = null
        })
      }
    })
    // setTimeout(()=>{
    //   setNavMenuActive(this)
    // },2000)
  }
}
</script>

<style scoped>
::v-deep .el-submenu.is-opened .connect-box {
   display: var(--connector-display);
}
.connect-box {
  position: absolute;
  left: 0;
  height: 25px;
  width: 100%;
  padding: var(--padding);
}
.connect-box .vertical-line {
  position: absolute;
  width: var(--connector-width);
  height: 100%;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
  background: var(--connector-color);
}
.connect-box .hor-line {
  width: 100%;
  height: var(--connector-width);
  top: 0;
  background: var(--connector-color);
}
.el-menu--horizontal > li {
  display: inline-block;
  float: none;
}
.rect_left,
.rect_center,
.rect_right {
  display: flex;
  position: absolute;
  flex-wrap: var(--wrap);
  align-items: flex-start;
}
.row-col-layout .rect_left,
.row-col-layout .rect_center,
.row-col-layout .rect_right,
.width-auto {
  position: relative;
}
.rect_left {
  left: 0;
  right: auto;
  justify-content: flex-start;
}
.rect_center {
  position: relative;
  margin: 0 auto;
  /*left:50%;*/
  /*right:auto;*/
  /*transform:translateX(-50%);*/
  /*width: fit-content;*/
  justify-content: center;
}
.rect_right {
  right: 0;
  left: auto;
  justify-content: flex-end;
}

/* 有三级分类的二级菜单宽度没有充满 */
.el-menu--horizontal > .el-submenu > /deep/.el-submenu__title {
  display: inline-block;
  vertical-align: top;
  /*height: 100% !important;*/
  height: var(--height1) !important;
}
/* 一级导航的样式 */
.el-menu--horizontal > .el-submenu /deep/.el-submenu__title,
.el-menu--horizontal > /deep/.el-menu-item {
  /* WebKit browsers*/
  /* display: inline-block; */
  color: var(--color) !important;
  font-size: var(--fontSize);
  font-family: var(--fontFamily);
  font-weight: var(--fontWeight);
  height: var(--height);
  /*height: auto;*/
  line-height: var(--lineHeight);
  text-align: var(--textAlign);
  text-decoration: var(--textDecoration);
  letter-spacing: var(--letterSpacing);
  writing-mode: var(--writingMode);
  font-style: var(--fontStyle);
  border-width: var(--borderWidth);
  border-style: var(--borderStyle);
  border-color: var(--borderColor) !important;
  width: var(--navWidth);
  box-shadow: var(--boxShadow);
  opacity: var(--topNavOpacity);
  transform: var(--topNavRotate);
}
.el-menu--horizontal > .el-submenu,
.el-menu--horizontal > /deep/.el-menu-item {
  margin-bottom: var(--liMarginBottom);
}
/* 一级导航的边距 */
.el-menu--horizontal > /deep/.el-submenu:not(:last-child) > .el-submenu__title,
.el-menu--horizontal > /deep/.el-menu-item:not(:last-child) {
  margin-right: var(--navMargin);
}
/* 二级导航的最后一行 */
::v-deep.el-menu--horizontal.is-menu-three {
  left: 0 !important;
}
.el-menu--horizontal .el-menu--popup .el-submenu:last-child /deep/.el-submenu__title {
  border-bottom: var(--borderBottomWidth) var(--borderStyle) var(--borderColor);
  margin-bottom: 0;
}
.el-menu--horizontal /deep/.el-menu--popup .el-menu-item:last-child {
  border-bottom: var(--borderBottomWidth) var(--borderStyle) var(--borderColor);
  margin-right: 0;
  line-height: var(--borderBottomWidthLineHeight0);
  margin-bottom: 0;
}

.el-menu--horizontal .el-submenu:last-child /deep/.el-submenu__title {
  opacity: var(--opacity);
}
.el-menu--horizontal > /deep/.el-menu-item,
.el-menu--horizontal > /deep/.el-submenu > .el-submenu__title {
  padding: var(--padding);
}

::v-deep.el-menu--horizontal > .el-submenu > .el-submenu__title,
::v-deep.el-menu--horizontal > .el-menu-item {
  background: var(--backgroundColor);
  background-image: var(--backgroundImage);
  background-size: var(--backgroundSize);
  background-position: var(--backgroundPosition);
  background-repeat: var(--backgroundRepeat);
  background-color: var(--backgroundColor);
  border-radius: var(--borderRadius);
}

/* 二级导航的样式 */
::v-deep.el-menu--horizontal .el-menu .el-menu-item,
::v-deep.el-menu--horizontal .el-menu .el-submenu__title {
  color: var(--color);
  font-style: var(--fontStyle);
  font-size: var(--fontSize);
  font-family: var(--fontFamily);
  font-weight: var(--fontWeight);
  line-height: var(--liLineHeight);
  height: var(--liHeight);
  /*height: auto !important;*/
  width: var(--liWidth);
  /*min-width: var(--liMinWidth) !important;*/
  /*max-width: var(--liMaxWidth);*/
  border-width: var(--liBorderWidth);
  border-style: var(--borderStyle);
  border-color: var(--borderColor);
  border-radius: var(--liBorderRadius);
  text-align: var(--textAlign);
  text-decoration: var(--textDecoration);
  letter-spacing: var(--letterSpacing);
  writing-mode: var(--writingMode);
  background-image: var(--liBackgroundImage);
  background-size: var(--liBackgroundSize);
  background-position: var(--liBackgroundPosition);
  background-repeat: var(--liBackgroundRepeat);
  background-color: var(--liBackgroundColor);
  margin-bottom: var(--liMargin);
  padding: var(--liPadding);
  opacity: var(--liOpacity);
  transform: var(--liRotate);
  box-shadow: var(--selectBoxShadowStyle);
  white-space: var(--liWidthAutoWrap);
}
/* 有三级分类的二级菜单标题没有跟随textAlign改变 */
::v-deep.el-menu--horizontal .el-menu .el-submenu__title > span {
  text-align: var(--textAlign);
  /*width: 100%;*/
  height: 100%;
}
/*下拉列表的悬浮样式*/
::v-deep.rect > .el-submenu.is-opened > .el-submenu__title {
  /*background-color: transparent;*/
  color: var(--hoverColor) !important;
  font-size: var(--hoverFontSize) !important;
  font-family: var(--hoverFontFamily) !important;
  font-weight: var(--hoverFontWeight) !important;
  border-width: var(--hoverBorderWidth);
  border-style: var(--hoverBorderStyle);
  border-color: var(--hoverBorderColor) !important;
  /*background: var(--hoverBackground);*/
  line-height: var(--hoverLineHeight);
  text-align: var(--hoverTextAlign);
  text-decoration: var(--hoverTextDecoration);
  letter-spacing: var(--hoverLetterSpacing);
  writing-mode: var(--hoverWritingMode);

  background: var(--hoverBackgroundColor) !important;
  background-image: var(--hoverBackgroundImage) !important;
  background-size: var(--hoverBackgroundSize) !important;
  background-position: var(--hoverBackgroundPosition) !important;
  background-repeat: var(--hoverBackgroundRepeat) !important;
  background-color: var(--hoverBackgroundColor) !important;
}
::v-deep .el-submenu.is-opened > .el-submenu__title > .icon {
  display: inline-block;
  transform: rotate(180deg);
}
::v-deep .el-menu--popup .el-submenu.is-opened > .el-submenu__title > .icon {
  display: inline-block;
  transform: rotate(180deg);
}
::v-deep .el-menu--popup .el-submenu.is-opened > .el-submenu__title > .icon.old-icon-style {
  display: inline-block;
}
::v-deep .el-submenu.is-opened,
::v-deep.el-menu--horizontal .el-menu .el-menu-item:hover,
.el-menu--horizontal > .el-submenu /deep/.el-submenu__title:hover {
  color: var(--hoverColor) !important;
  font-size: var(--hoverFontSize) !important;
  font-family: var(--hoverFontFamily) !important;
  font-weight: var(--hoverFontWeight) !important;

  background: var(--liHoverBackgroundColor) !important;
  background-image: var(--liHoverBackgroundImage) !important;
  background-size: var(--liHoverBackgroundSize) !important;
  background-position: var(--liHoverBackgroundPosition) !important;
  background-repeat: var(--liHoverBackgroundRepeat) !important;
  background-color: var(--liHoverBackgroundColor) !important;

  line-height: var(--liHoverLineHeight);
  text-align: var(--hoverTextAlign);
  text-decoration: var(--hoverTextDecoration);
  letter-spacing: var(--hoverLetterSpacing);
  writing-mode: var(--hoverWritingMode);
  font-style: var(--liHoverFontStyle);
  -webkit-border-radius: var(--liHoverBorderRadius);
  -moz-border-radius: var(--liHoverBorderRadius);
  border-radius: var(--liHoverBorderRadius);
}
::v-deep .el-submenu.is-opened,
::v-deep.el-menu--horizontal .el-menu .el-menu-item.is-active,
.el-menu--horizontal > .el-submenu /deep/.el-submenu__title.is-active {
  color: var(--activeColor) !important;
  font-size: var(--activeFontSize) !important;
  font-family: var(--activeFontFamily) !important;
  font-weight: var(--activeFontWeight) !important;

  background: var(--liActiveBackgroundColor) !important;
  background-image: var(--liActiveBackgroundImage) !important;
  background-size: var(--liActiveBackgroundSize) !important;
  background-position: var(--liActiveBackgroundPosition) !important;
  background-repeat: var(--liActiveBackgroundRepeat) !important;
  background-color: var(--liActiveBackgroundColor) !important;

  line-height: var(--liActiveLineHeight);
  text-align: var(--activeTextAlign);
  text-decoration: var(--activeTextDecoration);
  letter-spacing: var(--activeLetterSpacing);
  writing-mode: var(--activeWritingMode);
  font-style: var(--liActiveFontStyle);
  border-radius: var(--liActiveBorderRadius);
}
/* 二级导航 悬浮 */
::v-deep.el-menu--horizontal .el-menu .el-submenu > .el-submenu__title:hover,
::v-deep.el-menu--horizontal .el-menu .el-menu-item:hover {
  border-width: var(--liHoverBorderWidth);
  border-style: var(--liHoverBorderStyle);
  border-color: var(--liHoverBorderColor) !important;
}
::v-deep.el-menu--horizontal .el-menu .el-submenu:last-child > .el-submenu__title:hover,
::v-deep.el-menu--horizontal .el-menu .el-menu-item:last-child:hover{
  border-bottom-width: var(--liHoverBorderBottomWidth);
}
/* 二级导航 选中 */
::v-deep.el-menu--horizontal .el-menu .el-submenu > .el-submenu__title.is-active,
::v-deep.el-menu--horizontal .el-menu .el-menu-item.is-active {
  border-width: var(--liActiveBorderWidth);
  border-style: var(--liActiveBorderStyle);
  border-color: var(--liActiveBorderColor) !important;
}
/*//todo */
/* 二级导航列表框 */
::v-deep.el-submenu .el-menu--horizontal:not(.customMenu) .el-menu--popup {
  height: var(--liHeight);
  /*height: auto !important;*/
  width: var(--liWidth);
  min-width: var(--liMinWidth) !important;
  max-width: var(--liMaxWidth);
  /*width: var(--popperWidth);*/
  /*height: var(--popperHeight);*/
  background: var(--ulBackgroundColor);
  background-image: var(--ulBackgroundImage);
  background-size: var(--ulBackgroundSize);
  background-position: var(--ulBackgroundPosition);
  background-repeat: var(--ulBackgroundRepeat);
  background-color: var(--ulBackgroundColor);
  border-width: var(--ulBorderWidth);
  border-style: var(--ulBorderStyle);
  border-color: var(--ulBorderColor);
  -webkit-border-radius: var(--ulBorderRadius);
  -moz-border-radius: var(--ulBorderRadius);
  border-radius: var(--ulBorderRadius);
  padding: var(--ulPadding);
  opacity: var(--ulOpacity);
  transform: var(--ulRotate);
  box-shadow: var(--ulBoxShadow);
}
::v-deep.el-menu--collapse .el-menu .el-submenu,
::v-deep .el-menu--popup,
::v-deep .el-submenu .el-menu-item {
  min-width: 10px !important;
}
::v-deep.el-menu.el-menu--horizontal {
  border-bottom: none;
}
/* 一级导航 悬浮状态样式*/
::v-deep.el-menu--horizontal > .el-submenu > .el-submenu__title:hover,
::v-deep.el-menu--horizontal > .el-menu-item:hover {
  /*background: var(--hoverBgColor) !important;*/

  background: var(--hoverBackgroundColor) !important;
  background-image: var(--hoverBackgroundImage) !important;
  background-size: var(--hoverBackgroundSize) !important;
  background-position: var(--hoverBackgroundPosition) !important;
  background-repeat: var(--hoverBackgroundRepeat) !important;
  background-color: var(--hoverBackgroundColor) !important;

  border-width: var(--hoverBorderWidth);
  border-style: var(--hoverBorderStyle);
  border-color: var(--hoverBorderColor) !important;
}
::v-deep.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  color: var(--hoverColor) !important;
}
::v-deep.el-menu--horizontal > .el-submenu > .el-submenu__title:hover,
::v-deep.el-menu--horizontal > .el-menu-item:hover {
  font-size: var(--hoverFontSize) !important;
  font-family: var(--hoverFontFamily) !important;
  font-weight: var(--hoverFontWeight) !important;
  color: var(--hoverColor) !important;
  height: var(--hoverHeight);
  line-height: var(--hoverLineHeight);
  text-align: var(--hoverTextAlign);
  text-decoration: var(--hoverTextDecoration);
  letter-spacing: var(--hoverLetterSpacing);
  writing-mode: var(--hoverWritingMode);
  font-style: var(--hoverFontStyle);
  -webkit-border-radius: var(--hoverBorderRadius);
  -moz-border-radius: var(--hoverBorderRadius);
  border-radius: var(--hoverBorderRadius);
}
/*激活状态样式 */
::v-deep.el-menu--horizontal > .el-submenu.is-active > .el-submenu__title,
::v-deep.el-menu--horizontal > .el-menu-item.is-active {
  /*background: var(--activeBgColor) !important;*/

  background: var(--activeBackgroundColor) !important;
  background-image: var(--activeBackgroundImage) !important;
  background-size: var(--activeBackgroundSize) !important;
  background-position: var(--activeBackgroundPosition) !important;
  background-repeat: var(--activeBackgroundRepeat) !important;
  background-color: var(--activeBackgroundColor) !important;

  border-width: var(--activeBorderWidth);
  border-style: var(--activeBorderStyle);
  border-color: var(--activeBorderColor) !important;
  height: var(--activeHeight);
  /*height: auto;*/
  line-height: var(--activeLineHeight);
  text-align: var(--activeTextAlign);
  text-decoration: var(--activeTextDecoration);
  letter-spacing: var(--activeLetterSpacing);
  writing-mode: var(--activeWritingMode);
  font-style: var(--activeFontStyle);
  -webkit-border-radius: var(--activeBorderRadius);
  -moz-border-radius: var(--activeBorderRadius);
  border-radius: var(--activeBorderRadius);
}
/* 没有二级菜单的一级导航高度自适应没有跟随行高改变 */
::v-deep.el-menu--horizontal > .el-menu-item.is-active {
  /*height: var(--noSubActiveHeight);*/
}
::v-deep.el-menu--horizontal > .el-submenu.is-active > .el-submenu__title,
::v-deep.el-menu--horizontal > .el-menu-item.is-active {
  font-size: var(--activeFontSize) !important;
  font-family: var(--activeFontFamily) !important;
  font-weight: var(--activeFontWeight) !important;
  color: var(--activeColor) !important;
}
::v-deep.el-menu--horizontal > .el-menu-item.is-active {
  background: var(--activeBackgroundColor) !important;
  background-image: var(--activeBackgroundImage) !important;
  background-size: var(--activeBackgroundSize) !important;
  background-position: var(--activeBackgroundPosition) !important;
  background-repeat: var(--activeBackgroundRepeat) !important;
  background-color: var(--activeBackgroundColor) !important;
}
::v-deep .el-submenu__title .el-submenu__icon-arrow {
  display: none;
}
.el-menu {
  background-color: transparent;
}

::v-deep .el-submenu__title svg {
  vertical-align: top;
  width: 100%;
  height: 100%;
}
::v-deep .el-submenu__title svg * {
  stroke: var(--color);
}
.el-submenu {
  background: transparent !important;
}
.el-menu--horizontal.el-menu {
  background: var(--backgroundColor);
}
::v-deep .el-submenu {
  position: relative;
}
::v-deep .el-menu--horizontal {
  position: absolute !important;
  left: 0 !important;
  top: var(--ulTop) !important;
}
::v-deep .el-menu--horizontal .el-menu--horizontal {
  position: absolute !important;
  left: 0 !important;
  /*top: var(--liHeight) !important;*/
  top: 0 !important;
}

::v-deep .sub_menu_center .el-menu--horizontal {
  left: 50% !important;
  transform: translateX(-50%) !important;
}
::v-deep .sub_menu_center.custom_style_2 .el-menu--horizontal[data-connector-top='25']{
  transform: translate(-50%, 25px) !important;
}
::v-deep .sub_menu_right .el-menu--horizontal {
  left: auto !important;
  right: 0 !important;
}

::v-deep .el-submenu .el-menu--horizontal .el-menu--horizontal {
  left: 99% !important;
}
::v-deep .el-menu--horizontal .el-menu .el-menu-item {
  overflow: hidden;
  text-overflow: ellipsis;
  /*white-space: nowrap;*/
  white-space: var(--liWidthAutoWrap);
}
::v-deep .el-menu--popup-bottom-start {
  margin-top: 0;
}
::v-deep .el-menu--popup {
  padding: 0;
}
.el-submenu__title .title_span {
  vertical-align: top;
}
.divide-box {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: var(--divideMargin);
  /* padding: var(--padding);
  padding-left: 0;
  padding-right: 0; */
}
.divide-box .line,
.divide-box .icon {
  display: block;
}
/*处理我们设置高度，未减去边框，造成有二级和没有二级的高度不一致 */
::v-deep li.el-menu-item {
  /*box-sizing: content-box;*/
}
::v-deep .el-menu--popup-right-start{
  margin: 0;
}
/*-------------------------导航菜单改造竖向菜单的样式调整---------------------------*/
.verticalNavMenu{
  display: block!important;
  width: 100%;
}
::v-deep.verticalNavMenu>.el-menu-item,
::v-deep.verticalNavMenu>.el-submenu{
  width: 100%;
}
::v-deep.verticalNavMenu>.el-submenu:not(:last-child) > .el-submenu__title,
::v-deep.verticalNavMenu>.el-menu-item:not(:last-child) {
  margin-right: 0;
  margin-bottom: var(--navMargin);
}
::v-deep.verticalNavMenu > .el-submenu > .el-submenu__title {
  display: block;
}
::v-deep.verticalNavMenu .el-menu--horizontal{
  left: 100% !important;
  top: 0 !important;
}

::v-deep.verticalNavMenu  .el-zoom-in-top-enter-active{
  -webkit-transform:scaleX(1);
  transform:scaleX(1);
  transform-origin: left center;
}
::v-deep.verticalNavMenu  .el-zoom-in-top-enter,
::v-deep.verticalNavMenu  .el-zoom-in-top-leave-active{
  -webkit-transform:scaleX(0);
  transform:scaleX(0);
  transform-origin: left center;
}
::v-deep .sub_menu_center .el-menu--horizontal.full-width-submenu,  ::v-deep .sub_menu_right .el-menu--horizontal.full-width-submenu {
  left: 0 !important;
}
::v-deep .el-menu--horizontal.sub_menu_right {
  right: 0 !important;
  left: auto !important;
}
::v-deep .el-menu--horizontal.sub_menu_left {
  right: auto !important;
  left: 0 !important;
}
::v-deep .el-menu--horizontal.sub_menu_center {
  left: 50% !important;
  transform: translate(-50%, 0) !important;
}
/*二级导航样式4-----连接符动画定制*/
.connect-box  .vertical-line{
  transform: translate(-50%, 0) scale(0);
  transition: all 0.6s ease-in-out;
}
.connect-box  .hor-line{
  transform: scale(0);
  transition: all 0.6s ease-in-out;
}

.el-submenu.animate-in .vertical-line,
.el-submenu.is-opened .vertical-line,
.hover_animate .el-submenu:hover .vertical-line{
  transform: translate(-50%, 0) scale(1);
}
.el-submenu.animate-in .hor-line,
.el-submenu.is-opened .hor-line,
.hover_animate .el-submenu:hover .hor-line{
  transform: none;
}
</style>
